import React, { FC, useState, useEffect } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"


import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";

import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import { useHistory } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import Modal from 'react-modal';
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import { getHighestZindex } from "../../../smallnation/assets/ts/_utils";

const CreateJob: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [locationCounty, setLocationCounty] = useState([]);
  const [jobTypes, setJobType] = useState([]);
  const [educations, setEducation] = useState([]);
  const [categories, setCategory] = useState([]);
  //const [summary, setSummary] = useState([]);
  const [summary, setSummary] = useState<any>("");
  //const [experience, setExperience] = useState([]);
  const [experience, setExperience] = useState<any>("");

  const [companyList, setCompanyList] = useState([]);

  //const [salary, setSalary] = useState([]);
  const [salary, setSalary] = useState<any>("");
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const [query, setQuery] = useState("");
  //const [sourceCompanyId, setSourceCompanyId] = useState("");
  const [sourceCompanyId, setSourceCompanyId] = useState<any>("");

  const red = "red";

  let jobTitleGlobal = '';

  //get animated components wrapper
  const animatedComponentssoc = makeAnimated();

  // fetch filteres search results for dropdown
  // const loadOptions = () => {
  //   return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${socquery}`)
  //     .then((res) => res.json());
  // };

  const loadOptions = () => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // Set the content type based on your API requirements
      },
      body: JSON.stringify({ title: query }), // Convert data to JSON format
    };
   
    return fetch('https://wagesurvey.hometownopportunity.com/api/jobSugList', requestOptions)
      .then((res) => res.json());
  };

  //set default query terms
  const [socquery, setQuerysoc] = useState("");

  let subtitle;
  const [countyDisplayName, setCountyDisplayName] = useState('');
  const [collab, setCollabs] = useState('');
  const [socCode, setSocCode] = useState('');
  const [socCodeTitle, setSocCodeTitle] = useState('');
  const [jobCodeTitle, setJobCode] = useState('');
  const [wageList, setWageListObj] = useState('');
  const [jobCodeTitleInput, setJobCodeTitleInput] = useState('');


  const [dolWageLevel1, setDolWageLevel1] = useState('');
  const [dolWageLevel2, setDolWageLevel2] = useState('');
  const [dolWageLevel3, setDolWageLevel3] = useState('');
  const [dolWageLevel4, setDolWageLevel4] = useState('');

  const [dolWageHourlyLevel1, setDolWageHourlyLevel1] = useState('');
  const [dolWageHourlyLevel2, setDolWageHourlyLevel2] = useState('');
  const [dolWageHourlyLevel3, setDolWageHourlyLevel3] = useState('');
  const [dolWageHourlyLevel4, setDolWageHourlyLevel4] = useState('');

  const [surveyWageLevel1, setsurveyWageLevel1] = useState('');
  const [surveyWageLevel2, setsurveyWageLevel2] = useState('');
  const [surveyWageLevel3, setsurveyWageLevel3] = useState('');
  const [surveyWageLevel4, setsurveyWageLevel4] = useState('');

  const [surveyWageHourlyLevel1, setsurveyWageHourlyLevel1] = useState('');
  const [surveyWageHourlyLevel2, setsurveyWageHourlyLevel2] = useState('');
  const [surveyWageHourlyLevel3, setsurveyWageHourlyLevel3] = useState('');
  const [surveyWageHourlyLevel4, setsurveyWageHourlyLevel4] = useState('');

  // const [countListAr, setCountListAr] = useState([]);
  const [countListAr, setCountListAr] = useState({});
  const handleChange = (selectedOption) => {
    //alert(JSON.stringify(selectedOption));
    var title = selectedOption.title;
    jobTitleGlobal = selectedOption.title;
    setJobCode(title);
    setSocCodeTitle(title);
    setSocCode(selectedOption.socCode);

    setTimeout(function () { getWageInfoCall(); }, 2000);


  }


  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      width: '100%',
      maxWidth: '600px',
      marginRight: '-50%',
      position: 'absolute',
      zIndex: '999',
      transform: 'translate(-30%, -38%)',

    },
  };

  function handleChangeSalaryDesc(content) {
    setSalary(content);
  }
  function handleChangeExperienceDesc(content) {
    setExperience(content);
  }
  function validateCheck() {
    const checked = $('input[name="category_list"]:checked').length;
    //alert(checked);
    if (checked >= 3) {
      $('input[name="category_list"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="category_list"]').prop('disabled', false);
    }
  }
  function openModal() {
    setIsOpen(true);
  }

  function handleChangeSummaryDesc(content) {
    setSummary(content);
  }


  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';


  }
  function closeModal() {
    setIsOpen(false);
  }

  const handleChangecompany = (selectedOption) => {
    console.log(selectedOption);
  }

  const changeCountyTrigger = () => {
    //alert('400');
    getWageInfoCall();
  }

  const getWageInfoCall = () => {
    //var state = $("#stateId").val();
    //var county = $("#countyId").val();
    var job_code = $("#jobCodeTitle").html();
    var soc_code = $("#socCodeVal").html();

    var state = 'OH';
    //var county = 'Crawford County';

    ///##
    // var countyId = $("#countyId").val();    
    // if (countyId == "") {
    //   var county = 'Crawford County';
    // } else {
    //   var county = countListAr[countyId] + ' County';
    // }

    const countyIdRaw = $("#countyId").val();
const countyId = Array.isArray(countyIdRaw) ? countyIdRaw[0] : countyIdRaw;

let county: string;

if (!countyId) {
  county = "Crawford County";
} else {
  county = countListAr[countyId as string] + " County";
}

//     var countyId = $("#countyId").val();

// // let county: string;
// // if (!countyId || !countListAr[countyId]) {
// //   county = "Crawford County";
// // } else {
// //   county = countListAr[countyId] + " County";
// // }

    //##

    county = county == "" ? 'Crawford County' : county;
    setCountyDisplayName(county)
    //alert(socCodeTitle);
    // alert(job_code);
    const requestObject = {
      "stateCode": state,
      "county": county,
      //"job_code": jobCode,
      "job_code": job_code,
      "soccode": soc_code,
      //"soccode": socCode,

    }
    // console.log(JSON.stringify(objInputAvailableJobs));
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };

    services.getSurveyWageList(requestOptions).then((res) => {
      console.log(JSON.stringify(res))
      if (res) {
        setWageListObj(res);
        setDolWageLevel1('');
        setDolWageLevel2('');
        setDolWageLevel3('');
        setDolWageLevel4('');

        setDolWageHourlyLevel1('');
        setDolWageHourlyLevel2('');
        setDolWageHourlyLevel3('');
        setDolWageHourlyLevel4('');

        setsurveyWageLevel1('');
        setsurveyWageLevel2('');
        setsurveyWageLevel3('');
        setsurveyWageLevel4('');

        setsurveyWageHourlyLevel1('');
        setsurveyWageHourlyLevel2('');
        setsurveyWageHourlyLevel3('');
        setsurveyWageHourlyLevel4('');
        try {
          if (typeof (res.dolWage[0].level1) != "undefined" && res.dolWage[0].level1 != null) {
            // alert(res.dolWage[0].level1);
            setDolWageLevel1(res.dolWage[0].level1);
            setDolWageLevel2(res.dolWage[0].level2);
            setDolWageLevel3(res.dolWage[0].level3);
            setDolWageLevel4(res.dolWage[0].level4);
          }
        } catch (ex) {

        }


        try {
          if (typeof (res.dolWageHourly[0].level1) != "undefined" && res.dolWageHourly[0].level1 != null) {

            setDolWageHourlyLevel1(res.dolWageHourly[0].level1);
            setDolWageHourlyLevel2(res.dolWageHourly[0].level2);
            setDolWageHourlyLevel3(res.dolWageHourly[0].level3);
            setDolWageHourlyLevel4(res.dolWageHourly[0].level4);
          }
        } catch (ex) {

        }



        try {
          if (typeof (res.surveyWage[0].level1) != "undefined" && res.surveyWage[0].level1 != null) {
            setsurveyWageLevel1(res.surveyWage[0].level1);
            setsurveyWageLevel2(res.surveyWage[0].level2);
            setsurveyWageLevel3(res.surveyWage[0].level3);
            setsurveyWageLevel4(res.surveyWage[0].level4);
          }
        } catch (ex) {

        }



        try {
          if (typeof (res.surveyWageHourly[0].level1) != "undefined" && res.surveyWageHourly[0].level1 != null) {
            setsurveyWageHourlyLevel1(res.surveyWageHourly[0].level1);
            setsurveyWageHourlyLevel2(res.surveyWageHourly[0].level2);
            setsurveyWageHourlyLevel3(res.surveyWageHourly[0].level3);
            setsurveyWageHourlyLevel4(res.surveyWageHourly[0].level4);
          }
        } catch (ex) {

        }


      }

    });



  }
  const submitValue = () => {

    var industriesArray = [];
    $.each($("input[name='category_list']:checked"), function () {
      if ($(this).is(':checked')) {
        industriesArray.push($(this).val());
      }
    });
    var website_regex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
    // var website_regex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
    var validateEditorTxt = 1;
    var selectedcompanyname = sourceCompanyId.companyId;
    if (selectedcompanyname == "" || typeof (selectedcompanyname) == "undefined") {
      $("#companyIdValidMsg").show();
      $(window).scrollTop($('#companyIdValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#companyIdValidMsg").hide();
    }



    if ($('#approval_status').val() == "") {
      $("#statusValidMsg").show();
      $(window).scrollTop($('#statusValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#statusValidMsg").hide();
    }

    if ($('#job_title').val() == "") {
      $("#jobtitleValidMsg").show();
      $(window).scrollTop($('#jobtitleValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#jobtitleValidMsg").hide();
    }

    /*if (jobCodeTitle == "") {
      $('#jobcodeValidMsg').show();
      $(window).scrollTop($('#jobcodeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $('#jobcodeValidMsg').hide();
    }

    if (socCode == "") {
      $("#soccodeValidMsg").show();
      $(window).scrollTop($('#soccodeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#soccodeValidMsg").hide();
    } */

    if ($('#job_type').val() == "") {
      $("#jobtypeValidMsg").show();
      $(window).scrollTop($('#jobtypeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#jobtypeValidMsg").hide();
    }

    if ($('#education').val() == "") {
      $("#educationValidMsg").show();
      $(window).scrollTop($('#educationValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#educationValidMsg").hide();
    }

    if ($('#countyId').val() == "") {
      $("#joblocationValidMsg").show();
      $(window).scrollTop($('#joblocationValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#joblocationValidMsg").hide();
    }

    if ($('#career_level').val() == "") {
      $("#careerLevelValidMsg").show();
      $(window).scrollTop($('#careerLevelValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#careerLevelValidMsg").hide();
    }
    var how_apply = $('#how_to_apply').val();

    var portallink: any = $('#portal_link').val();
    var portalvalid = website_regex.test(portallink);
    if (portallink != '') {
      console.log(portalvalid);
      if (portalvalid == true) {
        console.log('true val');
        $("#portalLinkValidregex").hide();
      }
      else {
        console.log('false val');
        $("#portalLinkValidregex").show();
        $(window).scrollTop($('#portalLinkValidregex').position().top);
        validateEditorTxt = 0;
      }
    }
    else {
      $("#portalLinkValidregex").hide();
    }

    /* if (how_apply == "") {
       $("#howtoapplyValidMsg").show();
       $(window).scrollTop($('#howtoapplyValidMsg').position().top);
       validateEditorTxt = 0;
     } else {
       $("#howtoapplyValidMsg").hide();
     } */

    /*if(how_apply != "" && website_regex.test(how_apply)==false){
      $("#howtoapplyValidregex").show();
        $(window).scrollTop($('#howtoapplyValidregex').position().top);
      validateEditorTxt = 0;
    }else{
      $("#howtoapplyValidregex").hide();
    } */

    if (industriesArray.length < 1) {
      $("#categoryValidMsg").show();
      validateEditorTxt = 0;
    }
    else {
      $("#categoryValidMsg").hide();
    }

    if (summary == "") {
      $("#summaryValidMsg").show();
      $(window).scrollTop($('#summaryValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#summaryValidMsg").hide();
    }

    if (experience == "") {
      $("#experienceValidMsg").show();
      $(window).scrollTop($('#experienceValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#experienceValidMsg").hide();
    }

    if (salary == "") {
      $("#salaryValidMsg").show();
      $(window).scrollTop($('#salaryValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#salaryValidMsg").hide();
    }
    console.log(validateEditorTxt);
    if (validateEditorTxt == 0) {
      return false;
    }


    const requestObject =
    {
      "siteId": 2,
      "companyId": selectedcompanyname,
      "countyId": $("#countyId").val(),
      "jobTypeId": $('#job_type').val(),
      "educationId": $('#education').val(),
      "title": $("#job_title").val(),
      "summary": summary,
      "experiance": experience,
      "career": $("#career_level").val(),
      "apply": $("#how_to_apply").val(),
      "jobApplyUrl": $('#portal_link').val(),
      "reference": $("#reference_code").val(),
      "salary": salary,
      "jobCategoryRelId": industriesArray,
      "status": $("#approval_status").val()
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn
        //'Authorization': accessTokenIn
      },
      body: JSON.stringify(requestObject)
    };
    services.adminCreateJob(requestOptions).then((res) => {

      if (res.code == '200') {
        $("#addjobsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addjobsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/joblist');
        }, 1000);
      }
      else {
        $("#addjobfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addjobfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }

    });


  }

  function applylink() {
    const applycheck = $('input[name="companyportal_consent"]:checked').length;
    if (applycheck > 0) {
      $('#portallinkdiv').show();
    }
    else {
      $('#portal_link').val('');
      $('#portallinkdiv').hide();
    }
  }

  function getAdminProfilesList() {
    var searchTxt = "";//$('#search_input').val();
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var itemsPerPage = '15000';
    var pageNumberV = '1';
    var siteIdv = '2'
    //alert("309")
    services.adminGetCompanyList(siteIdv, itemsPerPage, pageNumberV, searchTxt, statuschk, sortBy, sortDir).then((res) => {
      console.log("#######################");
      console.log(JSON.stringify(res));
      //alert("314")
      if (res.data) {
        console.log(JSON.stringify(res));

        setCompanyList(res.data.content);
      }


    });
  }
  const animatedComponents = makeAnimated();
  const loadOptionsSource = (query, callback) => {
    // return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`).then((res) => res.json());
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var pageSize = '1000';
    var pageNumber = '1';
    var siteId = '2'
    console.log('******514 ***  ' + query);
    var queryval = query;
    var encoded_queryval = encodeURIComponent(queryval)

    //var endpoint= process.env.REACT_APP_AWS_API+`adminGetCompanyList?siteId=`+siteId+`&status=`+statuschk+`&pageNumber=`+pageNumber+`&pageSize=`+pageSize+`&sortBy=`+sortBy+`&sortDir=`+sortDir+`&title=&searchTxt=${query}`;

    var endpoint = process.env.REACT_APP_AWS_API + `adminGetCompanyList?siteId=` + siteId + `&status=` + statuschk + `&pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&sortBy=` + sortBy + `&sortDir=` + sortDir + `&title=&searchTxt=` + encoded_queryval;
    console.log(endpoint);
    

    //console.log(encoded_endpoint);
    fetch(endpoint).then(response => {
      response.json().then(data => {
        //console.log("202-->"+JSON.stringify(data));
        const results = data.content;
        //console.log(data.content);
        callback(results);
      });
    });

  };

  const getIndustryData = () => {
    services.getIndustryData().then((res) => {
      console.log("Industry data=" + JSON.stringify(res.data));
      setCategory(res.data.content);
    });
  }

  const handleInputChange = value => {
    setQuery(value);
  };

  useEffect(() => {
    $("#job_title").change(function () {
      var st: any = $("#job_title").val();
      setJobCodeTitleInput(st);
    });
    //validateCheck();
    $('#jobcodeValidMsg').hide();
    $(".se-dialog-tabs").hide();
    $('#soccodeValidMsg').hide();
    $('#portalLinkValidregex').hide();
    $('#portallinkdiv').hide();
    $('#addjobsuccessMessage').hide();
    $('#addjobfailMessage').hide();
    $("#summaryValidMsg").hide();
    $("#experienceValidMsg").hide();
    $("#salaryValidMsg").hide();
    $("#companyIdValidMsg").hide();
    $("#statusValidMsg").hide();
    $("#jobtitleValidMsg").hide();
    $("#jobtypeValidMsg").hide();
    $("#educationValidMsg").hide();
    $("#joblocationValidMsg").hide();
    $("#careerLevelValidMsg").hide();
    $("#howtoapplyValidMsg").hide();
    $('#howtoapplyValidregex').hide();
    $("#categoryValidMsg").hide();
    getAdminProfilesList();
    getIndustryData();
    services.getLocationCounty().then((res) => {
      console.log("getLocationCounty data=" + JSON.stringify(res.data));

      var countyArr = res.data.content;
      var countListArTemp = {};
      //alert(JSON.stringify(countyArr))
      for (var j = 0; j < countyArr.length; j++) {
        var atval = countyArr[j]['jobLocationCountyId'];
        countListArTemp[atval] = countyArr[j].name;        
      }
      setCountListAr(countListArTemp);

      setLocationCounty(res.data.content);
    });
    services.getJobType().then((res) => {
      /* console.log("setJobType data=" + JSON.stringify(res.data));
       setJobType(res.data.content); */

      var jobtype_unsort = res.data.content;
      var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
      array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));
      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Continuing Education';
      });
      setJobType(jobtypes_sorted);

    });
    services.getEducation().then((res) => {
      console.log("getEducation data=" + JSON.stringify(res.data));
      setEducation(res.data.content);
    });
    /*services.getIndustryData().then((res) => {

      console.log("Industry data=" + JSON.stringify(res.data));

      setCategory(res.data.content);

    }); */
    //alert($('input[name="category_list"]:checked').length);
  }, []);

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };
  return (
    <>
      <PageTitle breadcrumbs={[]}>Post a Job</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Company Name</label>

                </div>
                <AsyncSelect
                  cacheOptions
                  components={animatedComponents}
                  getOptionLabel={(e: any) => e.name}
                  getOptionValue={(e) => e.companyId}
                  loadOptions={loadOptionsSource}
                  onInputChange={(value) => setQuery(value)}
                  //onInputChange={handleInputChange}
                  //onChange={handleChangecompany}
                  onChange={(value) => setSourceCompanyId(value)}
                />
                {/* <select className="form-select" id="companyId" name="companyId" aria-label="Select example">
                  <option selected value="" >Select Company</option>
                  {
                    companyList.map((data, index) => (
                      <option value={data.companyId} >{data.name}</option>
                    ))}
                </select> */}
                <div id="companyIdValidMsg" style={{ color: red }} className="error">Company Name is required.</div>
                {/*
              {...register("companyId", {
                  required: "Company is required."
                })}
              <ErrorMessage
                  errors={errors}
                  name="companyId"
                  className="invalid-feedback"
                  render={({ messages }) => {
                    console.log("messages", messages);
                    return messages
                      ? Object.entries(messages).map(([type, message]) => (
                        <p style={{ color: red }} className="error">{message}</p>
                      ))
                      : null;
                  }}
                /> */}
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className=" required form-label">Status</label>
                  {/* <small className="mb-3">Overall Approval Status</small> */}
                </div>
                <select id="approval_status" name="approval_status" className="form-select" aria-label="Select example" >
                  <option value="" >Select Status</option>
                  <option value="published">Published</option>
                  <option value="pending">Pending</option>
                </select>
                <div id="statusValidMsg" style={{ color: red }} className="error">Approval Status is required.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Title</label>

                </div>
                <input type="text" id="job_title" name="job_title" className="form-control" placeholder="" />
                <div id="jobtitleValidMsg" style={{ color: red }} className="error">Job Title is required.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Standardized Job Code</label>

                </div>

                <AsyncSelect
                  cacheOptions
                  components={animatedComponentssoc}
                  getOptionLabel={(e: any) => e.title}
                  getOptionValue={(e) => e.socCode}
                  loadOptions={loadOptions}
                  onInputChange={(value) => setQuerysoc(value)}
                  onChange={handleChange}
                // onChange={(value) => setSocCode(value)}
                />

                <div id="jobcodeValidMsg" style={{ color: red }} className="error">Job Code is required.</div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Soc Code</label>
                  <span id="socCodeVal">{socCode}</span>
                </div>

                <div id="soccodeValidMsg" style={{ color: red }} className="error">Soc Code is required.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Type</label>

                </div>
                <select className="form-select" id="job_type" name="job_type" aria-label="Select example" >
                  <option selected value="" >Select Job Type</option>
                  {
                    jobTypes.map((data, index) => (
                      <option value={data.jobTypeId} >{data.name}</option>
                    ))}
                </select>
                <div id="jobtypeValidMsg" style={{ color: red }} className="error">Job Type is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Education</label>

                </div>
                <select className="form-select" id="education" name="education" aria-label="Select example" >
                  <option value='' selected>Select Education</option>
                  {
                    educations.map((data, index) => (
                      <option value={data.educationId}>{data.name}</option>
                    ))}
                </select>
                <div id="educationValidMsg" style={{ color: red }} className="error">Education is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job is Located in which county</label>

                </div>
                <select className="form-select"  onChange={changeCountyTrigger} id="countyId" name="countyId" aria-label="Select example" >
                  <option selected value="" >Select Job Location</option>
                  {
                    locationCounty.map((data, index) => (
                      <option value={data.jobLocationCountyId} >{data.name}</option>
                    ))}
                </select>
                <div id="joblocationValidMsg" style={{ color: red }} className="error">Job Location is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Career Level</label>

                </div>
                <select className="form-select" id="career_level" name="career_level" aria-label="Select example" >
                  <option selected value=''>Select</option>
                  <option value="Entry-Level">Entry-Level</option>
                  <option value="Mid-Level">Mid-Level</option>
                  <option value="Management/Supervisor">Management/Supervisor</option>
                  <option value="Executive-Level">Executive Level</option>
                </select>
                <div id="careerLevelValidMsg" style={{ color: red }} className="error">Career Level is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Additional Instructions to Apply </label>
                  <small>Max 250 Characters</small>

                </div>
                <input type="text" id="how_to_apply" name="how_to_apply" className="form-control" placeholder="" maxLength={250} />
                <div id="howtoapplyValidMsg" style={{ color: red }} className="error">Additional instructions to apply is required.</div>
                <div id="howtoapplyValidregex" style={{ color: red }} className="error">Please enter valid website URL.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="form-label">Reference Code</label>
                  <small className="vhidden"> Reference Code </small>
                </div>
                <input type="text" id="reference_code" name="reference_code" className="form-control" placeholder="" />
              </div>
            </div>


            <div className="col-lg-12 mb-4">
              <input className="form-check-input" type="checkbox" name="companyportal_consent" value="Y" id="companyportal_consent1" onClick={() => applylink()} />  <label className="form-check-label" htmlFor="defaultCheck1"> Check this box to receive applicants on your external website </label>
            </div>

            <div className="col-lg-12 mb-4" id="portallinkdiv">
              <div className="d-flex"><label htmlFor="firstName" className="form-label mr-2">Link to job portal:  </label> <small>Link Should start with http or https. (Ex: http://www.example.com)</small></div>
              <input type="text" className="form-control" name="portal_link" id="portal_link" placeholder="" />

              <div id="portalLinkValidregex" style={{ color: red }} className="error">Please enter valid link.</div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Summary</label>


                </div>
                {/*<h2>editor area</h2> */}

                <SunEditor
                  setOptions={{
                    height: "400",  
                    position: "relative",                
                    
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSummaryDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />

                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  
                  id="summaryId"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setSummary(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}
                <div id="summaryValidMsg" style={{ color: red }} className="error">Summary is required.</div>
                {/*  <textarea className="form-control textarea" placeholder="Summary" id="summary" name="summary" spellcheck="false" {...register("summaryinfo", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 characters' }
                        })}></textarea>
                        <ErrorMessage
                          errors={errors}
                          name="summaryinfo"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Experience / Certification Required</label>


                </div>
                {/*<h2>editor area</h2>*/}
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                  }}
                  id="experienceId"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                    //editor.setData(profileDescription);
                    //editor.setData(profileDescription);

                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setExperience(data);
                    console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    position: "relative",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeExperienceDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />

                <div id="experienceValidMsg" style={{ color: red }} className="error">Experience is required.</div>
                {/* <textarea className="form-control textarea" placeholder="Experience / Certification" id="experience" name="experience" spellcheck="false" {...register("expCertification", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 characters' }
                        })}></textarea>
                         <ErrorMessage
                          errors={errors}
                          name="expCertification"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12"> Wage Data </div>


            <div className="col-lg-12 ">
              <div className="mb-10">
                <button type="button" onClick={openModal} className="reg-button mt-2 mb-5">WAGE DATA</button>
                <Modal
                  isOpen={modalIsOpen}
                  onAfterOpen={afterOpenModal}
                  onRequestClose={closeModal}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <div className="d-flex justify-content-between">
                    <h2 ref={(_subtitle) => (subtitle = _subtitle)}>WAGE DATA</h2>
                    <button onClick={closeModal} className="wage-close">close</button>
                  </div>

                  <div className="wd-modal-auto">
                  <table className="table wage-table ">
                    <tr>
                      <td>
                        <b>Location: </b> OH, Crawford County
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>Job Title: </b> {jobCodeTitleInput}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>Standardized Job Title: </b> <span id="jobCodeTitle">{jobCodeTitle}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>SOC CODE: </b> <span >{socCode}</span>
                      </td>
                    </tr>


                  </table>

                  
                  <table className="table wage-data-tb pj-wd" >
                    <thead className="thead-light">
                      <tr >
                        <th scope="col" style={{paddingLeft:"15px"}}>SOURCE</th>
                        <th scope="col">Type</th>
                        <th scope="col">LEVEL-1</th>
                        <th scope="col">LEVEL-2</th>
                        <th scope="col">LEVEL-3</th>
                        <th scope="col">LEVEL-4</th>


                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <th scope="row" style={{paddingLeft:"15px"}} rowSpan={2}>DOL Wage Data</th>
                        <td id="">Yearly</td>
                        <td id="dol_level1">{dolWageLevel1}</td>
                        <td id="dol_level2">{dolWageLevel2}</td>
                        <td id="dol_level3">{dolWageLevel3}</td>
                        <td id="dol_level4">{dolWageLevel4}</td>

                      </tr>

                      <tr>
                        <td id="">Hourly</td>
                        <td id="dol_level1_hourly">{dolWageHourlyLevel1}</td>
                        <td id="dol_level2_hourly">{dolWageHourlyLevel2}</td>
                        <td id="dol_level3_hourly">{dolWageHourlyLevel3}</td>
                        <td id="dol_level4_hourly">{dolWageHourlyLevel4}</td>

                      </tr>

                      <tr>
                        <th scope="row" style={{paddingLeft:"15px"}} rowSpan={2}>Local Survey Data</th>

                        <td id="">Yearly</td>
                        <td id="com_level1">{surveyWageLevel1}</td>
                        <td id="com_level2">{surveyWageLevel2}</td>
                        <td id="com_level3">{surveyWageLevel3}</td>
                        <td id="com_level4">{surveyWageLevel4}</td>

                      </tr>


                      <tr>
                        <td id="">Hourly</td>
                        <td id="com_level1_hourly">{surveyWageHourlyLevel1}</td>
                        <td id="com_level2_hourly">{surveyWageHourlyLevel2}</td>
                        <td id="com_level3_hourly">{surveyWageHourlyLevel3}</td>
                        <td id="com_level4_hourly">{surveyWageHourlyLevel4}</td>

                      </tr>

                    </tbody>
                  </table>
                </div>

                </Modal>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Salary Benifits</label>


                </div>


                {/* <CKEditor
                    editor={ClassicEditor}
                    config={{
                      removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                    }}
                    id="salaryId"
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                      console.log('Editor is ready to use!', editor);
                      //editor.setData(profileDescription);
                      //editor.setData(profileDescription);

                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setSalary(data);
                      console.log({ event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log('Blur.', editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log('Focus.', editor);
                    }}
                  /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    position: "relative",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSalaryDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />

                <div id="salaryValidMsg" style={{ color: red }} className="error">Salary Benifits is required.</div>

              </div>


            </div>

            <div className="row">

              <div className="col-lg-12 mb-10">
                <div className="mb-5">
                  <div className="d-flex flex-column ">
                    <label className="required form-label">Job Industry</label><small>Max 3 Categories</small>
                  </div>
                </div>
                <div className="row">

                  {

                    categories.map((data, index) => (
                      <div className="col-md-6 mb-4  form-check form-check-custom form-check-solid"><input className="form-check-input" type="checkbox" value={data.catId} name="category_list" id="category" onClick={() => validateCheck()} />  <label className="form-check-label" htmlFor="defaultCheck1"> {data.name} </label></div>

                    ))

                  }


                  <div id="categoryValidMsg" style={{ color: red }} className="error">Please Check at least 1 Category.</div>

                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "135px" }}>Post a Job </button>


            </div>
            <div id="addjobsuccessMessage" className="alert alert-success" role="alert">Job Posted Successfully</div>

            <div id="addjobfailMessage" className="alert alert-danger" role="alert">Please try again</div>
          </div>
        </div>
      </form>

    </>
  )
}
export { CreateJob }